var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-button-group',{staticClass:"mx-1"},_vm._l((_vm.characters),function(character){return _c('b-btn',{key:character,attrs:{"variant":"primary"},on:{"click":function($event){return _vm.changed(character)}}},[_vm._v(_vm._s(character))])}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }